/*@ngInject*/
const DynamicGridExtension = function ($rootScope, coreConstant, $uibModal) {

    $rootScope.$on(coreConstant.event.functionExecute, function(event, customOptions, context) {
        if (customOptions.functionClass==='DynamicGridPopup') {
            $uibModal.open({
                templateUrl: '/dynamicGridModal.tpl.html',
                controller: 'dynamicGridController',
                windowClass: 'dynamicGridModal',
                resolve: {
                    options: () => {
                        return {
                            customOptions: customOptions,
                            context: context,
                        };
                    }
                },
                keyboard: false,
                backdrop: 'static'
            });
        }
    }.bind(this));

};

angular.module('gw-um-extensions')
    .service('dynamicGridExtension', DynamicGridExtension);
